import { createSlice } from "@reduxjs/toolkit";

export const productTypesSlice = createSlice({
  name: 'productTypes',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startProductTypes: (state) => { state.isLoading = true; },
    setProductTypes: (state, { payload: { data = null, error = null}}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startProductTypes, setProductTypes } = productTypesSlice.actions;

export default productTypesSlice;
